import script from "./PuntosExtra.vue?vue&type=script&setup=true&lang=ts"
export * from "./PuntosExtra.vue?vue&type=script&setup=true&lang=ts"

import "./PuntosExtra.vue?vue&type=style&index=0&id=2ade11b2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2ade11b2"]])

export default __exports__